<template>
  <div class="boolean">
    <toggle ref="toggle" :initial-value="value" :label="label" @change="({ value }) => updateValue(value)" />
    <input type="hidden" :value="selectedAssociatedEntityId" :name="fieldName">
  </div>
</template>

<script>
import Toggle from '@/components/inputs/toggle'

export default {
  components: { Toggle },

  props: {
    associatedEntityId: {
      type: Number,
      required: true
    },
    fieldName: {
      type: String,
      required: false
    },
    initialValue: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      required: true
    }
  },

  emits: ['changed'],

  data() {
    return {
      selectedAssociatedEntityId: this.associatedEntityId,
      value: this.initialValue
    }
  },

  methods: {
    focus() {
      this.$refs.toggle.focus()
    },

    updateValue(value) {
      if (value) {
        this.selectedAssociatedEntityId = this.associatedEntityId
      } else {
        this.selectedAssociatedEntityId = null
      }

      this.value = value
      this.$emit('changed', this.selectedAssociatedEntityId)
    }
  }
}
</script>
